import React from 'react';
import { useLocation } from 'react-router-dom';
import './PortraitLock.css';
import { useIsMobile, useIsPortrait } from '../../hooks/useIsMobile';

/**
 * Phones use the app in portrait only — rotating to landscape used to flip
 * the layout to the (ungated) desktop UI. This overlay blocks landscape on
 * every screen EXCEPT the 3D viewer route, which is landscape-only and has
 * its own (inverse) OrientationOverlay.
 */
const PortraitLock = () => {
  const isMobile = useIsMobile();
  const isPortrait = useIsPortrait();
  const location = useLocation();
  const isViewerRoute = /\/view(\?|$)/.test(location.pathname + location.search)
    || location.pathname.endsWith('/view');

  if (!isMobile || isPortrait || isViewerRoute) return null;

  return (
    <div className='portrait-lock-overlay' role='alert'>
      <div className='portrait-lock-overlay__phone'>
        <i className='fas fa-mobile-alt' aria-hidden='true'></i>
      </div>
      <div className='portrait-lock-overlay__title'>Rotate your device</div>
      <div className='portrait-lock-overlay__hint'>
        This screen works in portrait mode
      </div>
    </div>
  );
};

export default PortraitLock;
